import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";

export const General: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Service Account
            <CpErrorWarningArrayIcon names={[`name`, `description`, "group"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`group`}>Assign To Group</CpLabel>
                <CpTooltip
                  tooltipProps={{
                    title: `If a group is selected, service account will be assigned to selected group as a member.`,
                  }}
                />
              </CpLabelTooltip>
              <CpKindSelect kind="group" optionValue="name" name={`group`} style={{ width: 600 }} />
              <CpErrorWarning name={`group`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
